import { Notify } from 'vant'
import { accountRequest } from '@services'
import { localStorage } from '@utils/basicUtil'

export default {
  data () {
    return {
      challengeId: '',
      expiresAt: 0,
      totpCode: '',
      totpSeconds: 0,
      totpTimer: null,
      loginGeneration: 0
    }
  },
  beforeRouteLeave (to, from, next) {
    this.resetLoginSecurity()
    next()
  },
  beforeDestroy () {
    this.resetLoginSecurity()
  },
  methods: {
    stopTotpTimer () {
      clearInterval(this.totpTimer)
      this.totpTimer = null
    },
    resetLoginSecurity () {
      this.loginGeneration++
      this.stopTotpTimer()
      this.challengeId = ''
      this.expiresAt = 0
      this.totpCode = ''
      this.totpSeconds = 0
      this.submitLoading = false
      this.loginData.password = ''
      this.loginData.captcha = ''
      this.abnormalInfo = ''
    },
    loginError (text) {
      this.abnormalInfo = text
      Notify({ type: 'danger', message: text })
    },
    expireTotp () {
      this.resetLoginSecurity()
      this.loginError('验证已过期，请重新登录')
    },
    updateTotpCountdown () {
      this.totpSeconds = Math.max(0, Math.ceil((this.expiresAt - Date.now()) / 1000))
      if (!this.totpSeconds) this.expireTotp()
    },
    changeTotpCode (value) {
      this.totpCode = String(value).replace(/\D/g, '').slice(0, 6)
      this.abnormalInfo = ''
    },
    async acceptLoginToken (token) {
      if (typeof token !== 'string' || !token) {
        this.loginError('登录响应异常，请重新登录')
        return
      }
      this.stopTotpTimer()
      this.challengeId = ''
      this.expiresAt = 0
      this.totpCode = ''
      this.loginData.password = ''
      this.loginData.captcha = ''
      localStorage.set('X-Access-Token', token)
      await this.getCompanies()
    },
    async startLogin (postData) {
      if (this.submitLoading || this.challengeId) return
      const generation = this.loginGeneration
      this.submitLoading = true
      this.abnormalInfo = ''
      localStorage.delete('X-Access-Token')
      localStorage.delete('X-C-Token')
      try {
        const response = await accountRequest.login.firstFactorLogin(postData)
        if (generation !== this.loginGeneration) return
        if (!response.success || !response.result) {
          this.loginError(response.message || '登录失败，请稍后重试')
          return
        }
        const data = response.result
        if (data.twoFactorAuthType === 1) {
          if (typeof data.challengeId !== 'string' || !data.challengeId || !Number.isFinite(data.expiresIn) || data.expiresIn <= 0) {
            this.loginError('登录凭据异常，请重新登录')
            return
          }
          this.challengeId = data.challengeId
          this.expiresAt = Date.now() + data.expiresIn * 1000
          this.totpCode = ''
          this.loginData.password = ''
          this.loginData.captcha = ''
          this.stopTotpTimer()
          this.updateTotpCountdown()
          this.totpTimer = setInterval(this.updateTotpCountdown, 1000)
        } else {
          await this.acceptLoginToken(data.token)
        }
      } catch {
        if (generation === this.loginGeneration) this.loginError('登录异常，请稍后重试')
      } finally {
        if (generation === this.loginGeneration) this.submitLoading = false
      }
    },
    async verifyTotp () {
      if (this.submitLoading) return
      if (!this.challengeId || Date.now() >= this.expiresAt) {
        this.expireTotp()
        return
      }
      if (!/^[0-9]{6}$/.test(this.totpCode)) {
        this.loginError('请输入认证器生成的6位动态口令')
        return
      }
      const generation = this.loginGeneration
      this.submitLoading = true
      this.abnormalInfo = ''
      try {
        const response = await accountRequest.login.verifyTotp({ challengeId: this.challengeId, totpCode: this.totpCode })
        if (generation !== this.loginGeneration) return
        if (response.success) {
          await this.acceptLoginToken(response.result)
        } else {
          this.totpCode = ''
          const text = response.message || '验证失败，请稍后重试'
          if (/凭据已失效|已使用|尝试次数过多|已变更|账号不可用|账号凭据/.test(text)) this.resetLoginSecurity()
          this.loginError(text)
        }
      } catch {
        if (generation === this.loginGeneration) this.loginError('验证异常，请稍后重试')
      } finally {
        if (generation === this.loginGeneration) this.submitLoading = false
      }
    }
  }
}
